import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root',
})
export class FarmersApplicationService extends BaseService {
  constructor(private _http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this._http = _http;
  }

  postFarmersRegistrationData(data: any): Observable<any> {
    return this._http.post(
      environment.apiUrl + 'FarmerApplication/SubmitApplication',
      data
    );
  }

  getAllMiVendors(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetAllMIvenders'
    );
  }
  getAllSolarVendors(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetAllSolarVender'
    );
  }
  getPrimarySolarVendors(solarId): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetPrimarySolarVender?solarID='+solarId
    );
  }
  getSecondarySolarVendors(solarId): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetSecondarySolarVender?solarID=' + solarId
    );
  }

  getAllTank(): Observable<any> {
    return this._http.get(environment.apiUrl + 'FarmerApplication/GetAllTank');
  }
  getSolarMaster(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetSolarMaster'
    );
  }

  getComponentMaster(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetComponentMaster'
    );
  }
  
  getSchemeMaster(...args): Observable<any> {
    return this._http.get(`${environment.apiUrl}FarmerApplication/GetSchemeMaster?SchemeId=${args[0] ? args[0] : ''}`
    );
  }

  getFarmersLandId(farmerId): Observable<any> {
    return this._http.get(
      environment.apiUrl +
      'LandDetails/GetByFarmerID?FarmerID=' +
      farmerId
    );
  }

  getNotUsedLandsByFarmerID(farmerId: any) {
    return this._http.get<any>(`${environment.apiUrl}LandDetails/GetNotUsedLandsByFarmerID?FarmerID=${farmerId}`);
  }

  GetAllFarmerDetails(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetAllFarmerDetails'
    );
  }

  GetAllOutletDetails(villageCode: any): Observable<any> {
    // return this._http.get(
    //   `${environment.apiUrl}FarmerApplication/GetOutlatMaster?villageCode=${villageCode}`
    // );

    return this._http.post(
      environment.apiUrl + 'FarmerApplication/GetOutlatMaster',
      villageCode
    );
  }


  LetAllOutletDetails(): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}FarmerApplication/GetAllOutlatMaster`
    );
  }

  GetWorktypeMaster(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetWorkTypeMaster'
    );
  }

  GetFarmerDetailsByVillageCode(villageCode: string): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}FarmerApplication/GetFarmerDetailsByVillageCode/${villageCode}`
    );
  }

  GetFarmerAndLandByVillageCode(villageCode: string): Observable<any> {
    // return this._http.get(
    //   `${environment.apiUrl}FarmerApplication/GetFarmerLandByVillageCode/${villageCode}`
    // );
    return this._http.post(
      environment.apiUrl + 'FarmerApplication/GetFarmerLandByVillageCode',
      villageCode
    );
  }

  GetFarmerLandByFarmerIds(reqBody: any): Observable<any> {
    return this._http.post(
      environment.apiUrl + 'LandDetails/GetFarmerLandByFarmerID',
      reqBody
    );
  }

  getAllMIvenders(programId: string): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}FarmerApplication/GetAllMIvenders?ProgramId=${programId}`
    );
  }

  getApplicationIdsByFarmerIdForCR(farmerId: any){
    return this._http.get<any>(`${environment.apiUrl}ChangeRequest/GetApplicationIdsByFarmerIdForCR?FarmerId=${farmerId}`, { headers: this.buildHeaders() });
  }

  personalDetailsInsert_CR(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'ChangeRequest/PersonalDetailsInsert_CR', reqBody);
  }

  
  changeReqSubmitApplication(data: any): Observable<any> {
    return this._http.post(
      environment.apiUrl + 'ChangeRequest//SubmitApplication_CR',
      data
    );
  }
}
